import { updateURLSlugs } from "../../components/naviagtions/itemNavs/itemNavigationFunctions";
import { CategoryState, CategoryTreeNode } from "../../types/category";

interface CategoryAction {
  type: "GET_TREE" | "UPDATE_SELECTED_NODE" | "UPDATE_NAVIGATION_NODE" | "SET_COLLECTION_PRODUCT_COUNTS"; // ADD OTHERS HERE
  categoryTree?: CategoryTreeNode[];
  selectedNode?: CategoryTreeNode | null;
  productCounts?: Record<string, number>;
}

const initialState: CategoryState = {
  categoryTree: [],
  productCounts: {}
};

export default function categoryReducer(
  state = initialState,
  action: CategoryAction
) {
  switch (action.type) {
    case "GET_TREE":
      return {
        ...state,
        categoryTree: action.categoryTree,
      };
    case "UPDATE_SELECTED_NODE":
      // change the url to reflect the cat we are in
      updateURLSlugs(action.selectedNode, state.selectedNode);
      return {
        ...state,
        selectedNode: action.selectedNode,
      };
    case "UPDATE_NAVIGATION_NODE":
      // change the url to reflect the cat we are in but clear the url first
      updateURLSlugs();
      updateURLSlugs(action.selectedNode, state.selectedNode);

      return {
        ...state,
        selectedNode: action.selectedNode,
      };
    case "SET_COLLECTION_PRODUCT_COUNTS":
      return {
        ...state,
        productCounts: action.productCounts || {}
      };
    default:
      return state;
  }
}
